<template>
  <Step
    :step="{
      title: t('landingpages.steps.step-1.title'),
      content: t('landingpages.steps.step-1.content'),
    }"
  >
    <template #content>
      <div class="mt-2">
        <SnippetModal
          :landingpage-slug="landingpageSlug"
          :readable-prefix="readablePrefix"
          :readable-landingpage="readableLandingpage"
          :company-slug="companySlug"
          :company-site-url="companySiteUrl"
          :landingpage-type="landingpageType"
          small
          bgColor="white"
        />
      </div>
    </template>
  </Step>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import Step from '@/modules/landingpage/steps/Step.vue'
import SnippetModal from '@/modules/landingpages/snippet/index.vue'

const { t } = useI18n()

defineProps<{
  companySlug?: string | null
  companySiteUrl?: string
  landingpageSlug?: string | null
  readablePrefix?: string | null
  readableLandingpage?: string | null
  landingpageType?: string
}>()
</script>
